import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { UnauthorizedError } from '@/core/types/errors/http-error'

export function createDeleteProfileImageUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function () {
    const { token } = await tokenService.getToken()

    if (!token) {
      throw new UnauthorizedError()
    }
    const res = await httpClient
      .version('v1')
      .addHeaders(AUTH_HEADER(token))
      .delete('/website/buyer/delete/image')
    return res.data
  }
}
